<template>
    <v-app>
        <router-view/>

        <v-snackbar
            v-for="message in $root.messages"
            :key="message.key"
            :timeout="3000"
            v-model="message.visible"
            :color="message.type"
            top>
            {{ message.message }}
            <v-btn dark icon @click.native="message.visible = false">
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>
    </v-app>
</template>

<script>
export default {
    data() {
        return {}
    },
    name: 'App'
}
</script>

<style>
.pre-line {
    white-space: pre-line;
}
.cursor-pointer {
    cursor: pointer;
}
</style>
